<template>
    <div name="marketing-use" class="component">
        <strong>(선택) 개인정보 마케팅 활용</strong><br/><br/>
        <table class="table" style="width: 100%; text-align: center">
            <thead>
                <th><strong>수집</strong><strong>ᆞ</strong><strong>이용 목적&nbsp;</strong></th>            
                <th><strong>항목</strong>&nbsp;</th>            
                <th><strong>보유ᆞ이용기간</strong></th>  
            </thead>
            <tbody>
                <tr>
                    <td>솔닥 서비스 개발 및 맞춤 서비스 제공, 새로운 서비스 안내, 이벤트 등 광고성 정보 제공</td>
                    <td>의료기관명, 의료기관 전화번호, 담당 의료인 이름, 휴대전화 번호, 이메일, 의료기관 홈페이지</td>
                    <td>개인정보 처리방침에 따라 이용자의 이용계약 해지(회원 탈퇴) 시까지</td>
                </tr>
            </tbody>
        </table>
        ※	마케팅을 위한 개인정보 수집ᆞ이용 동의를 거부하실 수 있으며, 거부하시는 경우에도 솔닥 서비스를 이용하실 수 있으나, 솔닥의 각종 소식 수신 및 이벤트 참여에 제한이 있을 수 있습니다. <br/><br/>
    </div>
</template>

<script>
export default {
    name: 'marketingUse'
}
</script>

<style scoped>
    .component{
        padding: 20px;
        padding-top: 40px;
        background: #FFFFFF;
    }
</style>


// WEBPACK FOOTER //
// src/pages/partners/contents/marketing/20230314.vue